import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  exportText: {
    id: 'studio.SVwJTM',
    defaultMessage: 'Export',
  },
  exportWithResources: {
    id: 'studio.ny2yoG',
    defaultMessage: 'Include resources in the export file.',
  },
  exportWithAssets: {
    id: 'studio.nAE0fd',
    defaultMessage: 'Include assets in the export file.',
  },
  exportWithScreenshots: {
    id: 'studio.fTbrdc',
    defaultMessage: 'Include screenshots in the export file.',
  },
  exportWithReadmes: {
    id: 'studio.SLy0Ae',
    defaultMessage: 'Include readme files in the export file.',
  },
});
